import { CLIENT_LOGIN, IS_LOADING, IS_LOADED, SHOW_ERROR, CLEAR_ERROR, REMOVE_TOKEN, CLIENT_TOKEN_UPDATE } from '../actions/type';

const initState = {
    isAuthenticated: false,
    isLoading: false,
    error: null,
    token: localStorage.getItem("laundry-client"),
    client: null
};

const clientReducer = (state = initState, action) => {
    switch (action.type) {
        case IS_LOADING:
            return {
                ...state,
                isLoading: true
            };
        case IS_LOADED:
            return {
                ...state,
                isLoading: false
            };
        case SHOW_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case CLEAR_ERROR:
            return {
                ...state,
                error: null
            };
        case CLIENT_LOGIN:
            localStorage.setItem("laundry-client", action.payload.token);
            return {
                ...state,
                isAuthenticated: true,
                token: action.payload.token,
                client: action.payload.client
            };
        case REMOVE_TOKEN:
            localStorage.removeItem("laundry-client");
            return {
                ...state,
                isAuthenticated: false,
                token: null,
                client: null
            };
        case CLIENT_TOKEN_UPDATE:
            return {
                ...state,
                client: {
                    ...state.client,
                    token: action.payload.token,
                    distributor: action.payload.distributor
                }
            };
        default:
            return state;
    }
};

export default clientReducer;